import { useBranding } from "@context/Branding";
import ModuleSwitcher from "./ModuleSwitcher";
import UserMenu from "./UserMenu";
import { ColorMode } from "./useColorMode";

type Props = { mode: ColorMode; onMode: (m: ColorMode) => void };

const AppHeader = ({ mode, onMode }: Props) => {
  const { companyName } = useBranding();

  return (
    <nav className="app-header navbar navbar-expand bg-body">
      <div className="container-fluid">
        <ul className="navbar-nav">
          <li className="nav-item">
            {/* AdminLTE's push-menu script handles this toggle (document-level click listener). */}
            <button type="button" className="nav-link" data-lte-toggle="sidebar" aria-label="Toggle sidebar">
              <i className="bi bi-list" />
            </button>
          </li>
          {companyName && (
            <li className="nav-item d-none d-md-block">
              <span className="nav-link fw-semibold">{companyName}</span>
            </li>
          )}
        </ul>

        <ul className="navbar-nav ms-auto align-items-center gap-1">
          <ModuleSwitcher />
          <UserMenu mode={mode} onMode={onMode} />
        </ul>
      </div>
    </nav>
  );
};

export default AppHeader;
